export default __webpack_public_path__ + "static/media/pork.a8b379dc.jpg";